<template>
    <div class="alert-box">
        <!-- Success Alert -->
        <v-alert v-model="alertSuccess" color="success" type="success" dismissible>
            {{alertSuccessMessage}}
        </v-alert>

        <!-- Info Alert -->
        <v-alert v-model="alertInfo" color="info" type="info" dismissible>
            {{alertInfoMessage}}
        </v-alert>

        <!-- Warn Alert -->
        <v-alert v-model="alertWarn" color="warning" type="warning" dismissible>
            {{alertWarnMessage}}
        </v-alert>

        <!-- Error Alert -->
        <v-alert v-model="alertError" color="error" type="error" dismissible>
            {{alertErrorMessage}}
        </v-alert>
    </div>
</template>

<script>
    export default {
        name: 'alert',
        data() {
            return {
                title: 'Alert'
            }
        },
        computed:{
            alertSuccess: {
                get(){
                    return this.$store.getters.alert.isAlertSuccess;
                },
                set(){
                    this.$store.commit('setAlert', {isAlertSuccess: false});
                }
            },
            alertInfo: {
                get(){
                    return this.$store.getters.alert.isAlertInfo;
                },
                set(){
                    this.$store.commit('setAlert', {isAlertInfo: false});
                }
            },
            alertWarn: {
                get(){
                    return this.$store.getters.alert.isAlertWarn;
                },
                set(){
                    this.$store.commit('setAlert', {isAlertWarn: false});
                }
            },
            alertError: {
                get(){
                    return this.$store.getters.alert.isAlertError;
                },
                set(){
                    this.$store.commit('setAlert', {isAlertError: false});
                }
            },

            alertSuccessMessage: {
                get(){
                    return this.$store.getters.alert.alertSuccessMessage;
                },
                set(){
                }
            },
            alertInfoMessage: {
                get(){
                    return this.$store.getters.alert.alertInfoMessage;
                },
                set(){
                }
            },
            alertWarnMessage: {
                get(){
                    return this.$store.getters.alert.alertWarnMessage;
                },
                set(){
                }
            },
            alertErrorMessage: {
                get(){
                    return this.$store.getters.alert.alertErrorMessage;
                },
                set(){
                }
            },
        }
    }
</script>

<style>
  .alert-box{
      width: 100%;
      position: fixed;
      top: 0px;
      z-index: 100;
  }

  .alert.alert{
      border: none !important;
  }
</style>